import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentMethods } from 'briteatlib';

@Component({
  selector: 'brt-payment-logos',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './payment-logos.component.html',
  styleUrl: './payment-logos.component.scss'
})
export class PaymentLogosComponent {
  paymentMethods = PaymentMethods;

}
